export default function (context, {value, name}) {
    let data = context.state[name];
    if (value) {
        let item = data.filters.filter(i => {
            return i.id === value;
        })[0];
        let index = data.filters.indexOf(item);
        data.filters.splice(index, 1);
        if (!data.filters[0]) {
            context.commit(name + '/set_filter');
        }
        if (data.filter === value) {
            if (index > 0) {
                if (index === data.filters.length) {
                    data.filter = data.filters[index - 1].id;
                } else {
                    data.filter = data.filters[index].id;
                }
            } else {
                data.filter = data.filters[0].id;
            }
        }
    } else {
        context.commit(name + '/set_filter');
        data.filter = data.filters[data.filters.length - 1].id
    }
    if(data.filter === value){
        data.defaultFilter = data.filters[0].id;
    }
}